import { createSelector } from 'reselect';
import { isEmpty } from 'Helpers/objects';

const messagesSelector = (state, { userId, itemId }) => state.chat && state.chat.threadMessages && state.chat.threadMessages[`${userId}_${itemId}`] || [];

const threadsSelector = state => {
    const newThreads = state.chat && state.chat.threads || [];

    return [...newThreads];
};

const threadSelector = createSelector(
    threadsSelector,
    (_, { userId }) => userId,
    (_, { itemId }) => itemId,
    (threads, userId, itemId) => threads.find(thread => thread.userId === userId && thread.itemId === itemId) || {}
);

const questionCloudSelector = state => (state.chat && state.chat.questionCloud) || {};

const sortedMessagesSelector = createSelector(
    messagesSelector,
    messages => messages.sort((a, b) => {
        return a.date - b.date;
    })
);

const unreadCountSelector = createSelector(
    sortedMessagesSelector,
    messages => messages.reduce((prev, msg) => prev + ((msg.info || msg.displayed || msg.isMine) ? 0 : 1), 0)
);

const lastMessageSelector = createSelector(
    sortedMessagesSelector,
    messages => messages[messages.length - 1]
);

const threadLastMessageSelector = (state, { userId, itemId }) => {
    const threads = state.chat.threads || [];
    const thread = threads.find(threadObj => threadObj.userId === userId && threadObj.itemId === itemId) || {};

    return thread.lastMsgTimestamp;
};

const threadStatusSelector = createSelector(
    threadsSelector,
    threadSelector,
    (_, thread) => thread.phoneRequestStatus
);

const threadPhoneSelector = createSelector(
    threadsSelector,
    threadSelector,
    (_, thread) => thread.phoneNumber
);

const threadOfferSelector = createSelector(
    threadsSelector,
    threadSelector,
    (_, thread) => {
        return isEmpty(thread) ? {} : {
            buyerOffer: thread.buyerOffer && typeof thread.buyerOffer === 'string' ? parseInt(thread.buyerOffer, 10) : thread.buyerOffer,
            sellerOffer: thread.sellerOffer && typeof thread.sellerOffer === 'string' ? parseInt(thread.sellerOffer, 10) : thread.sellerOffer,
            offerStatus: thread.offerStatus,
            offerId: thread.offerId,
            offerCategory: thread.offerCategory || ''
        };
    }
);

const threadMeetingSelector = (state, { userId, itemId }) => {
    const threads = state.chat && state.chat.threads || [];
    const thread = threads.find(thread => thread.userId === userId && thread.itemId === itemId);

    return isEmpty(thread) ? {} : {
        appointmentId: thread.appointmentId,
        bookingId: thread.bookingId,
        cancelledBy: thread.cancelledBy,
        date: thread.date,
        location: thread.location,
        meetingStatus: thread.meetingStatus,
        requestedBy: thread.requestedBy,
        phoneNumber: thread.phoneNumber,
        time: (thread.meetingDetails?.time || thread.time) ?? '',
        endTime: (thread.meetingDetails?.end_time || thread.endTime) ?? '',
        leadInfo: thread.leadInfo,
        type: thread.type
    };
};

const questionsSelector = createSelector(
    questionCloudSelector,
    (_, { userId }) => userId,
    (_, { itemId }) => itemId,
    (questionCloud, userId, itemId) => questionCloud[`${userId}_${itemId}`] || {}
);

export {
    sortedMessagesSelector,
    unreadCountSelector,
    lastMessageSelector,
    threadsSelector,
    threadSelector,
    threadStatusSelector,
    threadPhoneSelector,
    threadOfferSelector,
    threadMeetingSelector,
    threadLastMessageSelector,
    questionsSelector
};
